import * as React from "react";
import i18n from "../../i18n/i18n";
import * as classNames from "classnames";
import { ApplicationCardStatusType } from "../../models/enums/ApplicationCardStatusType";
import * as FontAwesome from "react-fontawesome";

interface ICardProps {
  title: string;
  children: React.ReactNode;
  iconName?: string;
  className?: string;
  isCollapsible?: boolean;
  isRequired?: boolean;
  isCollapsedByDefault?: boolean;
  isCardDataEditable?: boolean;
  editState?: boolean;
  isButtonDisabled?: boolean;
  canCardBeAcceptedOrRejected?: boolean;
  isCardAccepted?: ApplicationCardStatusType;
  isAcceptOrRejectButtonsDisabled?: boolean;
  isEditClicked?: (value: boolean) => void;
  onUpdateApplicationCardStatus?: (value: ApplicationCardStatusType) => void;
}

interface IState {
  isCollapsed: boolean;
}

export default class Card extends React.Component<ICardProps, IState> {
  constructor(props: ICardProps) {
    super(props);
    this.state = {
      isCollapsed: this.props.isCollapsedByDefault,
    };
  }

  private toggleCollapse() {
    if (this.props.isCollapsible) {
      this.setState({
        ...this.state,
        isCollapsed: !this.state.isCollapsed,
      });
    }
  }

  private acceptOrRejectedClicked(isAcceptedClicked: boolean) {
    if (isAcceptedClicked) {
      this.props.onUpdateApplicationCardStatus(ApplicationCardStatusType.Approved);
    }

    if (!isAcceptedClicked) {
      this.props.onUpdateApplicationCardStatus(ApplicationCardStatusType.Rejected);
    }

    if ((isAcceptedClicked && this.props.isCardAccepted === ApplicationCardStatusType.Approved) || (!isAcceptedClicked && this.props.isCardAccepted === ApplicationCardStatusType.Rejected)) {
      this.props.onUpdateApplicationCardStatus(ApplicationCardStatusType.NotSet);
    }
  }

  public render() {
    const { className, title, iconName, children, isCollapsible, isRequired, isCardDataEditable, editState, isButtonDisabled, canCardBeAcceptedOrRejected, isCardAccepted, isAcceptOrRejectButtonsDisabled } = this.props;

    const labelClasses = classNames({ required: isRequired, clickable: isCollapsible });
    const openCloseClass = classNames({
      "fa fa-plus": this.state.isCollapsed,
      "fa fa-minus": !this.state.isCollapsed,
    });

    const lockIcon = editState ? "lock-open" : "edit";
    const editButtonText = editState ? "Afslut redigering" : "Rediger";

    const acceptButtonClassName = isCardAccepted === ApplicationCardStatusType.NotSet || isCardAccepted === ApplicationCardStatusType.Resubmitted || isCardAccepted === ApplicationCardStatusType.Rejected ? "btn" : "btn btn-success";

    const rejectButtonClassName = isCardAccepted === ApplicationCardStatusType.NotSet || isCardAccepted === ApplicationCardStatusType.Resubmitted || isCardAccepted === ApplicationCardStatusType.Approved ? "btn" : "btn btn-red";

    return (
      <div data-ui-test={"step-guide-card-" + title} className={"card " + (className || "")}>
        <h2 onClick={() => this.toggleCollapse()} className={labelClasses} data-ui-test={title + "-card-toogle"}>
          {isCollapsible && (
            <span>
              <i className={openCloseClass} aria-hidden="true">
                &nbsp;
              </i>
            </span>
          )}
          {iconName && (
            <span>
              <FontAwesome name={iconName} />
              &nbsp;
            </span>
          )}
          <span data-ui-test="card-title">{i18n.t(title)}</span>
          <span className="pull-right">
            {canCardBeAcceptedOrRejected && (
              <span>
                <button disabled={isAcceptOrRejectButtonsDisabled} title="Godkend" style={{ marginTop: "-20px", marginRight: "10px" }} className={acceptButtonClassName} onClick={() => this.acceptOrRejectedClicked(true)} data-ui-test={"card-accept-button-for-" + title.toLowerCase()}>
                  <FontAwesome name={"check"} /> Godkend
                </button>
                <button disabled={isAcceptOrRejectButtonsDisabled} title="Afvis" style={{ marginTop: "-20px", marginRight: "10px" }} className={rejectButtonClassName} onClick={() => this.acceptOrRejectedClicked(false)} data-ui-test={"card-reject-button-for-" + title.toLowerCase()}>
                  <FontAwesome name={"minus-circle "} /> Afvis
                </button>
              </span>
            )}
            {isCardDataEditable && (
              <button disabled={isButtonDisabled} title="Rediger" style={{ marginTop: "-20px" }} className="btn btn-blue" onClick={() => this.props.isEditClicked(editState)} data-ui-test={"card-edit-button-for-" + title.toLowerCase()}>
                <FontAwesome name={lockIcon} /> {i18n.t(editButtonText)}
              </button>
            )}
          </span>
        </h2>

        {!this.state.isCollapsed && (
          <fieldset data-ui-test={"step-guide-card-fieldset-" + title} style={{ minWidth: "0px" }}>
            {children}
          </fieldset>
        )}
      </div>
    );
  }
}
